// import React, { Component } from "react";
// import { Link } from "react-router-dom";
// import LogoWhite from '../../assets/img/logo-white-small.png';
// export default class CustomerMobileHeader extends Component {
//     componentDidMount() {
//         if (window.KTLayout && window.KTLayout.Aside && typeof window.KTLayout.Aside.init === "function") {
//           window.KTLayout.Aside.init(); 
//         } else {
          
//           if (window.KTOffcanvas && typeof window.KTOffcanvas === "function") {
//             new window.KTOffcanvas("kt_aside", {
//               overlay: true,
//               baseClass: "kt-aside",
//               closeBy: "kt_aside_close_btn",
//               toggleBy: "kt_aside_mobile_toggler"
//             });
//           }
//         }
//       }
      
      

// render()
 


// {
//     return(<div id="kt_header_mobile" className="kt-header-mobile  kt-header-mobile--fixed ">
//             <div className="kt-header-mobile__logo">
//                 <Link to="/home">
//                     <img height="40" alt="Logo" src={LogoWhite} />
//                 </Link>
//             </div>
//             <div className="kt-header-mobile__toolbar">
//                 <button className="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left" id="kt_aside_mobile_toggler"><span></span></button>
//                 <button className="kt-header-mobile__toolbar-topbar-toggler" id="kt_header_mobile_topbar_toggler"><i className="flaticon-more"></i></button>
//             </div>
//         </div>)
// }


// }


// import React, { Component } from "react";
// import { Link, withRouter } from "react-router-dom";
// import LogoWhite from "../../assets/img/logo-white-small.png";

// class CustomerMobileHeader extends Component {
//   componentDidMount() {
//     this.initAside();
//   }

//   componentDidUpdate(prevProps) {
//     // Reinitialize on route change
//     if (this.props.location.pathname !== prevProps.location.pathname) {
//       this.initAside();
//     }
//   }

//   initAside = () => {
//     if (window.KTLayout && window.KTLayout.Aside && typeof window.KTLayout.Aside.init === "function") {
//       window.KTLayout.Aside.init(); // Metronic standard init
//     } else if (window.KTOffcanvas && typeof window.KTOffcanvas === "function") {
//       // Manual fallback for offcanvas init
//       new window.KTOffcanvas("kt_aside", {
//         overlay: true,
//         baseClass: "kt-aside",
//         closeBy: "kt_aside_close_btn",
//         toggleBy: "kt_aside_mobile_toggler",
//       });
//     }
//   };

//   render() {
//     return (
//       <div id="kt_header_mobile" className="kt-header-mobile kt-header-mobile--fixed">
//         <div className="kt-header-mobile__logo">
//           <Link to="/home">
//             <img height="40" alt="Logo" src={LogoWhite} />
//           </Link>
//         </div>
//         <div className="kt-header-mobile__toolbar">
//           <button
//             className="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left"
//             id="kt_aside_mobile_toggler"
//           >
//             <span></span>
//           </button>
//           <button
//             className="kt-header-mobile__toolbar-topbar-toggler"
//             id="kt_header_mobile_topbar_toggler"
//           >
//             <i className="flaticon-more"></i>
//           </button>
//         </div>
//       </div>
//     );
//   }
// }

// export default withRouter(CustomerMobileHeader);


import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import LogoWhite from "../../assets/img/logo-white-small.png";

class CustomerMobileHeader extends Component {
  componentDidMount() {
    this.initMobileHeader();
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.initMobileHeader();
    }
  }

  initMobileHeader = () => {
    // Sidebar init (left menu)
    if (window.KTLayout?.Aside?.init) {
      window.KTLayout.Aside.init();
    } else if (window.KTOffcanvas) {
      new window.KTOffcanvas("kt_aside", {
        overlay: true,
        baseClass: "kt-aside",
        closeBy: "kt_aside_close_btn",
        toggleBy: "kt_aside_mobile_toggler",
      });
    }

    // Topbar panel init (user panel)
    const topbarBtn = document.getElementById("kt_header_mobile_topbar_toggler");
    if (topbarBtn) {
      topbarBtn.onclick = () => {
        document.body.classList.toggle("kt-header__topbar--mobile-on");
      };
    }

    // Optional: close handler for mobile topbar
    const topbarClose = document.getElementById("kt_header_mobile_topbar_close");
    if (topbarClose) {
      topbarClose.onclick = () => {
        document.body.classList.remove("kt-header__topbar--mobile-on");
      };
    }
  };

  render() {
    return (
      <div id="kt_header_mobile" className="kt-header-mobile kt-header-mobile--fixed">
        <div className="kt-header-mobile__logo">
          <Link to="/service-list">
            <img height="40" alt="Logo" src={LogoWhite} />
          </Link>
        </div>
        <div className="kt-header-mobile__toolbar">
          <button
            className="kt-header-mobile__toolbar-toggler kt-header-mobile__toolbar-toggler--left"
            id="kt_aside_mobile_toggler"
          >
            <span></span>
          </button>
          <button
            className="kt-header-mobile__toolbar-topbar-toggler"
            id="kt_header_mobile_topbar_toggler"
          >
            <i className="flaticon-more"></i>
          </button>
        </div>
      </div>
    );
  }
}

export default withRouter(CustomerMobileHeader);
